import React from 'react';

import PriceSpan from 'common/components/formatters/PriceSpan';
import PropTypes from 'prop-types';

import { TranslatedMessage } from 'common/components/Intl';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Messages from 'apps/calculator/messages';

export default class SavingsBreakdown extends React.Component {
  static propTypes = {
    annualAmountSavings: PropTypes.number,
    currency: PropTypes.string,
  };

  static defaultProps = {
    annualAmountSavings: 0,
  };

  render() {
    const { annualAmountSavings, currency } = this.props;

    return (
      <div className="row">
        <div className="col-xs-10 col-xs-offset-1 calculator-page__card">
          <h2 className="savings-breakdown__title heading--title--small">
            <TranslatedMessage id={Messages.RESULTS_TITLE} />
          </h2>
          <div className="savings-breakdown__separator" />
          <div className="savings-breakdown__savings-wrapper">
            <h3 className="heading--subtitle--small savings-breakdown__savings-title">
              <TranslatedMessage id={Messages.RESULTS_TOTAL_YEARLY_SAVINGS} />
            </h3>
            <PriceSpan
              className="savings-breakdown__total-savings"
              amount={annualAmountSavings}
              currency={currency}
            />
          </div>
          <div className="row">
            <div className="savings-breakdown__savings-text col-xs-offset-1 col-xs-10">
              <TranslatedMessage
                id={Messages.RESULTS_USAGE}
                values={{
                  sup: <sup>*</sup>,
                  amount: (
                    <PriceSpan
                      amount={annualAmountSavings}
                      currency={currency}
                    />
                  ),
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="savings-breakdown__applicable-taxes col-xs-offset-1 col-xs-10 text--body--small">
              <TranslatedMessage
                id={Messages.RESULTS_USAGE_FINE_PRINT}
                values={{ sup: <sup>*</sup> }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
